export function windowResized() {
  return {type: WINDOW_RESIZED}
}

export const WINDOW_RESIZED = 'WINDOW_RESIZED'
